import React from "react";
import { X } from "lucide-react";
import { FileRow } from "@/components/intake/FileRow";

/** Transient upload list above the case composer: progress, verdict per file, retry for the failed ones. */
export function CaseUploads({ up }) {
  const { rows, busy } = up;
  if (!rows.length) return null;
  const active = rows.filter((r) => ["venter", "laster", "tolkes"].includes(r.status)).length;
  const failed = rows.filter((r) => r.status === "feil").length;
  const dups = rows.filter((r) => r.status === "duplikat").length;
  const ok = rows.length - active - failed - dups;
  const sum = active ? `Laster opp og tolker ${rows.length - active}/${rows.length}…` : [ok ? `${ok} lagt til saken` : null, dups ? `${dups} duplikat${dups > 1 ? "er" : ""}` : null, failed ? `${failed} mislykket` : null].filter(Boolean).join(" · ");
  return (
    <div className="mb-2 rounded-[18px] border border-black/[0.08] bg-[hsl(210_20%_98.5%)] p-2.5" data-testid="case-uploads">
      <div className="flex items-center justify-between gap-2 px-1 pb-1.5">
        <span className="text-[12px] font-medium" data-testid="case-uploads-summary">{sum}</span>
        {!busy ? <button type="button" onClick={up.clear} className="inline-flex h-6 items-center gap-1 rounded-full px-2 text-[11.5px] text-muted-foreground hover:bg-black/[0.05] hover:text-foreground" data-testid="case-uploads-close"><X className="h-3 w-3" /> Lukk</button> : null}
      </div>
      <ul className="space-y-1" data-testid="case-uploads-files">
        {rows.map((r) => <FileRow key={r.key} row={r} onRetry={up.retry} onRemove={up.dismiss} />)}
      </ul>
      {failed && !busy ? <p className="mt-1.5 px-1 text-[11px] text-muted-foreground">«Prøv igjen» sender bare den filen på nytt – ingenting dupliseres.</p> : null}
    </div>
  );
}
